import { openView } from '@/jsbridge';

export default function (groupId) {
  return openView({
    options: `tgc://native?moduleName=groupdetail&groupId=${groupId}`,
  });
}



// WEBPACK FOOTER //
// ../src/plugin/prototype/linkToGroup.js